var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPdfPttx = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FDC9A3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 18.7059C13 15.5447 13 13.9641 13.9958 12.9821C14.9917 12 16.5944 12 19.8 12H23.2C26.4056 12 28.0083 12 29.0042 12.9821C30 13.9641 30 15.5447 30 18.7059V24.2941C30 27.4553 30 29.0359 29.0042 30.0179C28.0083 31 26.4056 31 23.2 31H19.8C16.5944 31 14.9917 31 13.9958 30.0179C13 29.0359 13 27.4553 13 24.2941V18.7059Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 16.6996C23.857 16.6996 25.0355 16.6996 25.7678 17.4319C26.5 18.1641 26.5 19.3426 26.5 21.6996C26.5 24.0567 26.5 25.2352 25.7678 25.9674C25.0355 26.6996 23.857 26.6996 21.5 26.6996C19.143 26.6996 17.9645 26.6996 17.2322 25.9674C16.5 25.2352 16.5 24.0567 16.5 21.6996C16.5 19.3426 16.5 18.1641 17.2322 17.4319C17.9645 16.6996 19.143 16.6996 21.5 16.6996Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 25.9496L21.5 21.6996M25.75 17.4496L21.5 21.6996M25.75 25.9496L21.5 21.6996",
    stroke: "#1D1D1D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 28C11.5222 28 10 26.4988 10 24.6471V17.9412C10 13.7263 10 11.6188 11.3278 10.3094C12.6556 9 14.7926 9 19.0667 9H23.6C25.4778 9 27 10.5012 27 12.3529",
    stroke: "#1D1D1D",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPdfPttx);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pdf-pttx.9b574e5605875bee2c8f2bb06c281faa.svg";